/**
 * locations.company_id stores the company owner's user_id (uuid). The session
 * exposes that value as authUser.user_id for owners and staff alike, and
 * propData.id carries it when an admin works on behalf of a company.
 * Never use compacctnum here: rows saved with it disappear from the listings
 * and cannot be edited or deleted.
 */
export function resolveLocationCompanyId(authUser, propData) {
  const candidates = [propData?.id, authUser?.user_id];

  for (const value of candidates) {
    if (value != null && value !== '') return String(value);
  }

  return null;
}

export function resolveLocationUpdatedBy(authUser) {
  if (!authUser) return null;
  if (authUser.user_type === 'company') {
    return authUser.user_id ?? null;
  }
  return (
    authUser.staff?.staff_u_id ??
    authUser.staff?.user_id ??
    authUser.user_id ??
    null
  );
}

export function buildLocationAuditPayload(authUser, propData, formValues = {}) {
  const company_id = resolveLocationCompanyId(authUser, propData);
  const updated_by = resolveLocationUpdatedBy(authUser);
  return { ...formValues, company_id, updated_by };
}

export function getLocationAuditValidationMessage(company_id, updated_by) {
  if (!company_id || !updated_by) {
    return 'Missing company or user context. Please sign out and sign in again.';
  }
  return null;
}
